<div fxLayout="column">
  <br>
  <div *ngIf="hasValue" class="container">
    <mat-table class="table-list" [dataSource]="dataSource" multiTemplateDataRows>

      <ng-container matColumnDef="institution" >
        <mat-header-cell *matHeaderCellDef >Instituição</mat-header-cell>
        <mat-cell *matCellDef="let element" > {{element.institution}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="serviceContract">
        <mat-header-cell *matHeaderCellDef >Service Contract</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.serviceContract}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="cnae">
        <mat-header-cell *matHeaderCellDef> CNAE </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.cnae}} - {{element.cnaeDescription}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastModifiedDate">
        <mat-header-cell *matHeaderCellDef> Data de Criação </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.lastModifiedDate}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="options_edit">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element" class="options">
          <ng-container *ngIf="hasWriteAccess">
            <fa-icon class="edit-link" matTooltip="Excluir CNAE da lista" icon="trash"
              (click)="delete(element)"></fa-icon>
          </ng-container>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
    </mat-table>

    <mat-paginator
      [pageSizeOptions]="[defaultSizeItems,defaultSizeItems*2,defaultSizeItems*3,defaultSizeItems*4,defaultSizeItems*5,defaultSizeItems*6,defaultSizeItems*7,defaultSizeItems*8,defaultSizeItems*9,defaultSizeItems*10]"
      (page)="change($event)" [length]="totalItens">
    </mat-paginator>
  </div>
  <h5 *ngIf="!hasValue">Nenhum registro foi encontrado</h5>
</div>
